/**
 * User Repository Factory
 *
 * 환경 변수(USE_MOCK_DATA)에 따라 Mock 또는 GoogleSheets Repository를 반환합니다.
 */

import { env } from '@/core/config/env'
import { logger } from '@/core/logger'
import { MockUserRepository } from './MockUserRepository'
import { GoogleSheetsUserRepository } from './GoogleSheetsUserRepository'
import type { UserRepository } from './UserRepository'

/**
 * User Repository 인스턴스 생성
 *
 * env.USE_MOCK_DATA 값에 따라 자동으로 선택됩니다.
 *
 * @returns UserRepository 구현체
 */
export function createUserRepository(): UserRepository {
  if (env.USE_MOCK_DATA) {
    logger.info('🔧 Mock User Repository 사용')
    return new MockUserRepository()
  }

  logger.info('🔗 Google Sheets User Repository 사용')
  return new GoogleSheetsUserRepository()
}

/**
 * 전역 User Repository 인스턴스
 *
 * 애플리케이션 전체에서 동일한 인스턴스를 사용합니다.
 */
export const userRepository = createUserRepository()

// Re-export 타입
export type { UserRepository } from './UserRepository'
export type { User } from '../types/User'
